var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.629 15.219a10.9 10.9 0 0 1-3.362-.533.93.93 0 0 0-.962.229l-1.5 1.876a14.46 14.46 0 0 1-6.561-6.5l1.861-1.586a.97.97 0 0 0 .224-.976 10.6 10.6 0 0 1-.533-3.362.95.95 0 0 0-.939-.938h-3.3c-.509 0-1.128.229-1.128.943a16.334 16.334 0 0 0 16.2 16.2 1 1 0 0 0 .943-1.124v-3.287a.95.95 0 0 0-.943-.943Z"
  })));
};
export default SvgPhone;